import { UserTypeEnum } from '../models';

export const roles: { [key in UserTypeEnum]: UserTypeEnum } = {
  admin: 'admin',
  company: 'company',
  ally: 'ally',
  client: 'client',
};

export const rolesTranslatePlural: { [key in UserTypeEnum]: string } = {
  admin: 'Administrador',
  company: 'Empresas',
  ally: 'Aliados',
  client: 'Clientes',
};

export const rolesTranslate: { [key in UserTypeEnum]: string } = {
  admin: 'Administrador',
  company: 'Empresa',
  ally: 'Aliado',
  client: 'Cliente',
};

export const privileges: { [key in UserTypeEnum]: number } = {
  admin: 0,
  company: 1,
  ally: 2,
  client: 3,
};

export const privilegesTranslate: { [key: number]: string } = {
  0: 'Administrador',
};
